import React, {Component} from 'react';

export default class Test extends Component {


render(){

    //console.log(this.props);
    return(
        <div>
            {this.props.children}
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/Test/Test.js